import { createNativeStackNavigator } from '@react-navigation/native-stack';
import {
	View,
} from 'react-native';
import {
	Box,
	Button,
	Column,
	Icon,
	Row,
	Text,
} from 'native-base';
import getIsMobile from './OneHat/functions/getIsMobile';
import About from './screens/About';
import Account from './screens/Account';
import DrawerPageList from './screens/DrawerPageList';
import Home from './screens/Home';
import Questions from './screens/Questions';
import Question from './screens/Question';
import Settings from './screens/Settings';
import Privacy from './screens/Privacy';
import Terms from './screens/Terms';
import Utilities from './screens/Utilities';
import Test from './screens/Test';

import Music from './screens/Music';
import Catechism from './screens/Catechism';
import Endorsements from './screens/Endorsements';
import Faq from './screens/Faq';
import Contact from './screens/Contact';

import _ from 'lodash';


const Stack = createNativeStackNavigator();

export default function StackNavigator() {
	const isMobile = getIsMobile(),
		options = {
			headerBackTitle: 'Back',
			orientation: 'portrait',
		};
	if (!isMobile) {
		options.headerTitleAlign = 'center';
	}
	return <Stack.Navigator initialRouteName="Home" screenOptions={options}>
				<Stack.Screen name="Account" component={Account} options={{ title: 'Account', }} />
				<Stack.Screen name="Home" component={Home} options={{ headerShown: false, }} />
				<Stack.Screen name="Info" component={DrawerPageList} options={{ title: 'Info', }} />
				<Stack.Screen name="Questions" component={Questions} options={{ title: 'The Catechism', }} />
				<Stack.Screen name="Question" component={Question} options={{ title: 'The Catechism', }} />
				<Stack.Screen name="Settings" component={Settings} options={{ title: 'Settings', }} />
				<Stack.Screen name="Test" component={Test} options={{ title: 'Test', }} />
				<Stack.Screen name="Utilities" component={Utilities} options={{ title: 'Utilities', }} />
				
				<Stack.Screen name="About" component={About} options={{ title: 'About the App', }} />
				<Stack.Screen name="Contact" component={Contact} options={{ title: 'Contact Us', }} />
				<Stack.Screen name="Catechism" component={Catechism} options={{ title: 'About the Catechism', }} />
				<Stack.Screen name="Endorsements" component={Endorsements} options={{ title: 'Endorsements', }} />
				<Stack.Screen name="Faq" component={Faq} options={{ title: 'FAQ', }} />
				<Stack.Screen name="Music" component={Music} options={{ title: 'About the Music', }} />
				<Stack.Screen name="Privacy" component={Privacy} options={{ title: 'Privacy Policy', }} />
				<Stack.Screen name="Terms" component={Terms} options={{ title: 'Terms of Service', }} />
			</Stack.Navigator>;
}
